import {
  Contact
} from '../index';

declare var Object: any;
export interface PhoneInterface {
  "label"?: string;
  "value": string;
  "default"?: boolean;
  "order"?: number;
  "dtime"?: Date;
  "id"?: number;
  "contactId"?: number;
  contact?: Contact;
}

export class Phone implements PhoneInterface {
  "label": string;
  "value": string;
  "default": boolean;
  "order": number;
  "dtime": Date;
  "id": number;
  "contactId": number;
  contact: Contact;
  constructor(data?: PhoneInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `Phone`.
   */
  public static getModelName() {
    return "Phone";
  }

  /**
  * This method creates an instance of Phone for dynamic purposes.
  **/
  public static factory(data: PhoneInterface): Phone{
    return new Phone(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Phone',
      plural: 'Phones',
      path: 'Phones',
      idName: 'id',
      properties: {
        "label": {
          name: 'label',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "default": {
          name: 'default',
          type: 'boolean',
          default: false
        },
        "order": {
          name: 'order',
          type: 'number',
          default: 0
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "contactId": {
          name: 'contactId',
          type: 'number'
        },
      },
      relations: {
        contact: {
          name: 'contact',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'contactId',
          keyTo: 'id'
        },
      }
    }
  }
}
